<template>
  <transition name="fade">
    <div class="overlay" @click.self="close">
      <div class="upgrade-plan-wrapper">
        <div class="top">
          <div class="icon-wrapper">
            <i class="icon yule-icon-lock"></i>
          </div>
          <h4 class="title">
            {{ $t('errors.plans.not_allowed_modal.title') }}
          </h4>
          <p class="description">
            {{ $t('errors.plans.not_allowed_modal.description') }}
          </p>
        </div>
        <div class="bottom">
          <button type="button" class="btn btn-flat added-btn btn-primary" @click="navigateSalesPage">{{ $t('errors.plans.not_allowed_modal.button') }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

export default {
  data() {
    return {
      salesPageURL: "https://fanomena.io"
    }
  },
  mounted() {
    this.$store.commit('SET_MAIN_CONTAINER_CLASSES', ['locked'])
  },
  destroyed() {
   this.$store.commit('SET_MAIN_CONTAINER_CLASSES', [])
  },
  methods: {
    navigateSalesPage() {
      window.location.href = this.salesPageURL
    },
    close() {
      this.$store.commit('SET_NOT_ALLOWED_MODAL_SHOWN', false)
    }
  },
}
</script>
<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.overlay {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,0.5);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 900;
}
.upgrade-plan-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1000;
  transform: translateX(-50%) translateY(-50%);
  height: 35%;
  width: 40%;
  background: #FFF;
  border-radius: 4px;
  min-width: 615px;
  min-height: 300px;
}
.top {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75%;
  background: rgb(36, 39, 44);
  color: #FFF;
  flex-direction: column;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 0 10%;
  text-align: center;
}
.description {
  color: $grey-dark;
}
.icon-wrapper {
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFF;
  border-radius: 12px;
  color: $onyx;
}
.yule-icon-lock {
  font-size: 20px;
}
.bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25%;
}

@media only screen and (max-width: 600px) {
  .upgrade-plan-wrapper {
    width: 100%;
    height: 60%;
    min-height: unset;
    min-width: unset;
    max-height: unset;
  }
}
</style>



// WEBPACK FOOTER //
// PermissionNotAllowedModal.vue?2b74cae6